var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sla-heatmap" }, [
    _c("div", { staticClass: "chart-container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "heatmap-container" }, [
        _c(
          "div",
          { staticClass: "heatmap-grid" },
          _vm._l(24, function (hora) {
            return _c(
              "div",
              {
                key: hora - 1,
                staticClass: "heatmap-cell",
                style: _vm.getHeatmapStyle(
                  _vm.getCumplimientoForHour(hora - 1)
                ),
                attrs: {
                  title: `${_vm.formatHour(
                    hora - 1
                  )}: ${_vm.getCumplimientoForHour(hora - 1)}% cumplimiento`,
                },
              },
              [
                _c("div", { staticClass: "hour-label" }, [
                  _vm._v(_vm._s(_vm.formatHour(hora - 1))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "percentage-value" }, [
                  _vm._v(_vm._s(_vm.getCumplimientoForHour(hora - 1)) + "%"),
                ]),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm._m(1),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "heatmap-stats" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "stat-item" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "stat-content" }, [
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(_vm._s(_vm.getPeakHour())),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stat-label" }, [_vm._v("Hora Pico")]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "stat-item" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "stat-content" }, [
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(_vm._s(_vm.getLowestHour())),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stat-label" }, [
                  _vm._v("Hora Crítica"),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "stat-item" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "stat-content" }, [
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(_vm._s(_vm.getAveragePerformance()) + "%"),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stat-label" }, [
                  _vm._v("Promedio General"),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "stat-item" }, [
              _vm._m(5),
              _vm._v(" "),
              _c("div", { staticClass: "stat-content" }, [
                _c("div", { staticClass: "stat-value" }, [
                  _vm._v(_vm._s(_vm.getTrend())),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "stat-label" }, [_vm._v("Tendencia")]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h5", [
      _c("i", { staticClass: "fal fa-fire text-danger" }),
      _vm._v(" Mapa de Calor SLA por Hora del Día"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "heatmap-legend" }, [
      _c("div", { staticClass: "legend-item" }, [
        _c("div", { staticClass: "legend-color legend-excellent" }),
        _vm._v(" "),
        _c("span", [_vm._v("Excelente (90-100%)")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "legend-item" }, [
        _c("div", { staticClass: "legend-color legend-good" }),
        _vm._v(" "),
        _c("span", [_vm._v("Bueno (75-89%)")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "legend-item" }, [
        _c("div", { staticClass: "legend-color legend-average" }),
        _vm._v(" "),
        _c("span", [_vm._v("Promedio (60-74%)")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "legend-item" }, [
        _c("div", { staticClass: "legend-color legend-poor" }),
        _vm._v(" "),
        _c("span", [_vm._v("Bajo (< 60%)")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon text-success" }, [
      _c("i", { staticClass: "fal fa-clock" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon text-warning" }, [
      _c("i", { staticClass: "fal fa-exclamation-triangle" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon text-info" }, [
      _c("i", { staticClass: "fal fa-chart-line" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stat-icon text-primary" }, [
      _c("i", { staticClass: "fal fa-trending-up" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }